<template>
  <div class="tabs-container">
    <!-- 返回首页按钮 -->
    <el-button type="text" @click="goToHomePage">返回首页</el-button>

    <!-- Tab 切换 -->
    <el-tabs v-model="activeTab">

<!--      <el-tab-pane label="定制客户基础资料" name="custom-data">-->
<!--        <CustomData @switch-tab="switchTab"/>-->
<!--      </el-tab-pane>-->

      <el-tab-pane label="文件解析" name="file-results" :disabled="!getVisible(0)">
        <FileDescribe @switch-tab="switchTab"/>
      </el-tab-pane>

      <el-tab-pane label="参数解析" name="results-by-file" :disabled="!getVisible(0)">
        <ParamsParseResults/>
      </el-tab-pane>

      <el-tab-pane label="Check-List" name="results-by-param" :disabled="!getVisible(0)">
        <CheckList />
      </el-tab-pane>

      <el-tab-pane label="EQ" name="eq" :disabled="!getVisible(2)">
        <EQ />
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>

import CustomData from '@/components/CustomData.vue';
import FileDescribe from '@/components/FileDescribe.vue';
import ParamsParseResults from '@/components/ParamParse.vue';
import CheckList from '@/components/CheckList.vue';
import EQ from '@/components/EQ.vue';
import {getHistoryDetail} from "@/api/result_history";
import {mapState} from "vuex";

export default {
  name: 'ResultsPage',
  computed: {
    ...mapState(['stepSign']),
  },

  watch: {
    stepSign(currentSign) {
      if (currentSign > 0) {
        this.componentStepSign = currentSign
      }
    }
  },
  data() {
    return {
      componentStepSign: 0,
      activeTab: '',  // 默认显示文件解析结果
      historyMode: false,
    };
  },
  methods: {
    goToHomePage() {
      this.$router.push({ name: 'home' });
    },
    switchTab(tabName) {
      this.activeTab = tabName;
    },

    getVisible(tapIndex) {
      // console.log('tapIndex', tapIndex);
      // console.log('this.componentStepSign', this.componentStepSign);
      return this.componentStepSign >= tapIndex
    },

    async runHistoryMode() {
    },
  },
  components: {
    CustomData,
    FileDescribe,
    ParamsParseResults,
    CheckList,
    EQ,
  },

  mounted() {
    this.historyMode = this.$route.query.history;



    if (this.historyMode) {
      this.runHistoryMode()
    }

    // const tabName = this.$route.query.tab_name ? this.$route.query.tab_name : "file-results"
    const tabName = this.$route.query.tab_name ? this.$route.query.tab_name : "file-results"

    this.switchTab(tabName)
  }
};
</script>

<style scoped>
.tabs-container {
  margin: 0 50px; /* 水平居中 */

  height: 100%;
}
.el-tabs {
  position: sticky;
  top: 0;
  background-color: white; /* 确保背景不透明 */
  z-index: 10; /* 确保其在所有内容上方 */
}
</style>
